import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { FiAlertCircle } from "react-icons/fi";
import { useMaterialUIController } from "context";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

function AlertDelete({ isDelete, setIsDelete, handleConfirmDelete, name }) {
  const handleClose = () => {
    setIsDelete(false);
  };
  const { darkMode } = useMaterialUIController()[0];

  return (
    <Box>
      <Dialog
        // fullWidth={fullWidth}
        maxWidth="sm"
        open={isDelete}
        onClose={handleClose}
      >
        {/* <DialogTitle textAlign="center"> </DialogTitle> */}
        <DialogContent
          sx={{
            backgroundColor: darkMode ? "#1e1e1e" : "#FFFFFF",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            //width: "30rem",
            padding: "20px",
            gap: ".3em",
          }}
        >
          <Box sx={{ color: "red", display: "flex", alignItems: "center" }}>
            <WarningAmberRoundedIcon fontSize="medium" />
          </Box>
          <MDTypography variant="h5" sx={{ fontWeight: "600" }}>
            {" "}
            Do you want to Delete {name}?
          </MDTypography>
        </DialogContent>

        <DialogActions
          sx={{ backgroundColor: darkMode ? "#1e1e1e" : "#FFFFFF" }}
        >
          <MDBox display="flex" gap={2}>
            <MDButton
              variant="gradient"
              color="success"
              size="small"
              onClick={handleConfirmDelete}
            >
              Confirm
            </MDButton>
            <MDButton
              variant="gradient"
              color="error"
              size="small"
              onClick={handleClose}
            >
              Close
            </MDButton>
          </MDBox>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default AlertDelete;
